module.exports = __webpack_public_path__ + "img/all.a98daef8.png";